module.exports = __webpack_public_path__ + "static/media/Univers-reg.c673cc63.woff";